import { CONTACT_POINT_SYSTEM, REGEX_EXPS } from "utils/constants";
import {
  createCityNameValidation,
  normalizeTextField,
  stripAllSpaces,
} from "utils/helpers/validations";
import { validateNIR } from "utils/helpers/values";
import * as yup from "yup";

const validation = (messages, { hasPartner }) => {
  const string = yup
    .string()
    .typeError(messages.REQUIRED)
    .required(messages.REQUIRED);
  const nameValidation = yup
    .string()
    .transform(normalizeTextField)
    .typeError(messages.REQUIRED)
    .nullable()
    .required(messages.REQUIRED)
    .test(
      "is-valid-name",
      messages.INVALID_NAME,
      (value) => !value || REGEX_EXPS.name.test(value),
    );

  const cityName = createCityNameValidation(messages, REGEX_EXPS);

  const spouseValidationSchema = yup.object().shape({
    identity: yup.object().shape({
      user: yup.object().shape({
        gender: yup
          .string()
          .required(messages.REQUIRED)
          .typeError(messages.REQUIRED)
          .required(),
        lastname: nameValidation,
        firstname: nameValidation,
      }),
      telecoms: yup.object().shape({
        [CONTACT_POINT_SYSTEM.BIRTH_COUNTRY]: yup.object().shape({
          value: string,
        }),
        [CONTACT_POINT_SYSTEM.BIRTH_CITY]: yup.object().shape({
          value: cityName,
        }),
        [CONTACT_POINT_SYSTEM.DEPARTMENT_OF_BIRTH]: yup.object().shape({
          value: string,
        }),
      }),
      socialSecurityNumber: yup
        .string()
        .transform(stripAllSpaces)
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .test(
          "validateNIR",
          messages.INVALID_SOCIAL_SECURITY_NUMBER,
          function (value, ctx) {
            const result = validateNIR(value, this.parent);
            if (!result.valid)
              return ctx.createError({
                message: messages[result.reason] || messages.INVALID_VALUE,
              });

            return true;
          },
        ),
    }),
  });
  const childrenValidationSchema = yup.object().shape({
    identity: yup.object().shape({
      user: yup.object().shape({
        gender: string,
        lastname: nameValidation,
        firstname: nameValidation,
      }),
      telecoms: yup.object().shape({
        [CONTACT_POINT_SYSTEM.BIRTH_COUNTRY]: yup.object().shape({
          value: string,
        }),
        [CONTACT_POINT_SYSTEM.BIRTH_CITY]: yup.object().shape({
          value: cityName,
        }),
        [CONTACT_POINT_SYSTEM.DEPARTMENT_OF_BIRTH]: yup.object().shape({
          value: string,
        }),
      }),
      socialSecurityNumber: yup
        .string()
        .transform(stripAllSpaces)
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .test(
          "validateNIR",
          messages.INVALID_SOCIAL_SECURITY_NUMBER,
          function (value, ctx) {
            const result = validateNIR(value, this.parent);
            if (!result.valid)
              return ctx.createError({
                message: messages[result.reason] || messages.INVALID_VALUE,
              });

            return true;
          },
        ),
    }),
  });
  return yup.object().shape({
    spouse: hasPartner && spouseValidationSchema,
    children: yup.array().of(childrenValidationSchema),
  });
};

export default validation;
